import StyledTypo from '@tmh-website/styles/typo';
import styled from 'styled-components';

export const Container = styled(StyledTypo.Typography)`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 2px 8px;
  background: repeating-linear-gradient(
    45deg,
    ${props => props.theme.color.Yellow_500_Warning},
    ${props => props.theme.color.Yellow_500_Warning} 10px,
    ${props => props.theme.color.Yellow_700} 10px,
    ${props => props.theme.color.Yellow_700} 20px
  );
  background-color: ${props => props.theme.color.Yellow_500_Warning};
`;

export const Button = styled.button`
  appearance: none;
  padding: 0;
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  transition: opacity 0.25s ease-in-out;

  svg {
    display: block;
  }

  &:hover {
    opacity: 0.6;
  }
`;

export const Countdown = styled.span`
  display: inline-flex;
  gap: 2px;
  align-items: center;
  font-variant-numeric: tabular-nums;
`;

export const Expired = styled.span`
  padding: 3px 6px;
  line-height: 1;
  color: ${props => props.theme.color.Neutral_0_White};
  background-color: ${props => props.theme.color.Red_500_Danger};
  border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '4px')};
`;
